import React, { useEffect } from "react";
import Index from "./Components/Pages/IndexPage/Index";
import Login from "./Components/Pages/LoginPage/Login";
import Register from "./Components/Pages/RegisterPage/Register";
import Feedback from "./Components/Pages/FeedbackPage/Feedback";
import Reviews from "./Components/Pages/ReviewsPage/Reviews";
import Terms from "./Components/Pages/LegalPages/Terms";
import Privacy from "./Components/Pages/LegalPages/Privacy";
import Alert from "./Components/AlertSnackBar";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Boards from "./Components/Pages/BoardsPage/Boards";
import ProtectedRoute from "./Utils/ProtectedRoute";
import { loadUser } from "./Services/userService";
import Store from "./Redux/Store";
import FreeRoute from "./Utils/FreeRoute";
import Board from "./Components/Pages/BoardPage/Board";
const App = () => {
  useEffect(() => {
    loadUser(Store.dispatch);
  }, []);
  return (
    <BrowserRouter>
      <Alert />
      <Switch>
        <ProtectedRoute exact path="/boards" component={Boards} />
        <ProtectedRoute exact path="/board/:id" component={Board} />
        <FreeRoute exact path="/login" component={Login} />
        <FreeRoute exact path="/register" component={Register} />
        <Route exact path="/feedback" component={Feedback} />
        <Route exact path="/reviews" component={Reviews} />
        <Route exact path="/terms" component={Terms} />
        <Route exact path="/privacy" component={Privacy} />
        <Route exact path="/" component={Index} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
